var _path, _path2, _path3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeasehold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Leasehold_White_fill",
    "data-name": "Icon Leasehold White fill",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.95,
    height: 22.77,
    viewBox: "0 0 20.95 22.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_854",
    "data-name": "Path 854",
    className: "cls-2",
    d: "M10.92,59.225v-.01c-1.79-2.33-3.84-5.56-3.84-7.84a5.041,5.041,0,0,1,5.03-4.94h.25a5.027,5.027,0,0,1,5.01,4.92c0,2.31-2.06,5.54-3.85,7.87.23.01.46.02.68.05",
    transform: "translate(-1.61 -44.615)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    className: "cls-2",
    d: "M13.51,59.235c-.46.6-.9,1.14-1.29,1.59-.39-.45-.83-.99-1.3-1.6",
    transform: "translate(-1.61 -44.615)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_856",
    "data-name": "Path 856",
    className: "cls-2",
    d: "M10.08,61.085c.8,1,1.4,1.65,1.48,1.73l.66.7.67-.7c.08-.08.68-.72,1.47-1.71,4.21.35,6.38,1.6,6.38,2.18,0,.68-2.95,2.28-8.66,2.28s-8.65-1.6-8.65-2.28c0-.59,2.25-1.89,6.64-2.2h.01",
    transform: "translate(-1.61 -44.615)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_markupp_blue",
    "data-name": "icon markupp blue",
    transform: "translate(-1.61 -44.615)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1474",
    "data-name": "Group 1474"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_237",
    "data-name": "Ellipse 237"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    "data-name": "Path 857",
    className: "cls-2",
    d: "M20.74,63.285c0,.68-2.95,2.28-8.66,2.28s-8.65-1.6-8.65-2.28c0-.59,2.25-1.89,6.64-2.2h.01c.8,1,1.4,1.65,1.48,1.73l.66.7.67-.7c.08-.08.68-.72,1.47-1.71C18.57,61.455,20.74,62.705,20.74,63.285Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_858",
    "data-name": "Path 858",
    className: "cls-1",
    d: "M1.66,63.705c.4,2.01,3.73,3.15,7.49,3.52C5.13,66.765,2.1,65.395,1.66,63.705Zm7.11-4.32c-3.65.43-6.72,1.61-7.11,3.48.43-1.62,3.28-2.97,7.13-3.46C8.78,59.4,8.78,59.4,8.77,59.385Zm6.25,7.84c3.76-.37,7.09-1.51,7.49-3.52C22.07,65.395,19.04,66.765,15.02,67.225Zm.64-7.81-.02.02c3.71.52,6.45,1.84,6.87,3.43C22.13,61.045,19.2,59.875,15.66,59.415Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1848",
    "data-name": "Group 1848"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_859",
    "data-name": "Path 859",
    className: "cls-1",
    d: "M13.52,59.225a.01.01,0,0,1-.01.01c.23.01.46.03.69.04C13.98,59.245,13.75,59.235,13.52,59.225Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_860",
    "data-name": "Path 860",
    className: "cls-1",
    d: "M22.54,63.035a.508.508,0,0,0-.03-.17c-.42-1.59-3.16-2.91-6.87-3.43l.02-.02c1.69-2.34,3.53-5.48,3.53-8.08a6.856,6.856,0,0,0-6.86-6.72h-.22a6.864,6.864,0,0,0-6.85,6.74c0,2.57,1.83,5.7,3.51,8.03.01.01.01.02.02.02-3.85.49-6.7,1.84-7.13,3.46a.508.508,0,0,0-.03.17,2.105,2.105,0,0,0-.02.25,2.275,2.275,0,0,0,.02.26.453.453,0,0,0,.03.16c.44,1.69,3.47,3.06,7.49,3.52.27.03.54.06.82.08.24.02.48.03.72.04.46.03.93.04,1.39.04s.94-.01,1.41-.04c.24-.01.47-.02.71-.04.28-.02.55-.05.82-.08,4.02-.46,7.05-1.83,7.49-3.52a.453.453,0,0,0,.03-.16,2.276,2.276,0,0,0,.02-.26A2.106,2.106,0,0,0,22.54,63.035ZM7.08,51.375a5.041,5.041,0,0,1,5.03-4.94h.25a5.027,5.027,0,0,1,5.01,4.92c0,2.31-2.06,5.54-3.85,7.87.23.01.46.02.68.05-.23-.01-.46-.03-.69-.04-.46.6-.9,1.14-1.29,1.59-.39-.45-.83-.99-1.3-1.6v-.01C9.13,56.885,7.08,53.655,7.08,51.375Zm5,14.19c-5.71,0-8.65-1.6-8.65-2.28,0-.59,2.25-1.89,6.64-2.2h.01c.8,1,1.4,1.65,1.48,1.73l.66.7.67-.7c.08-.08.68-.72,1.47-1.71,4.21.35,6.38,1.6,6.38,2.18C20.74,63.965,17.79,65.565,12.08,65.565Z"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    className: "cls-1",
    cx: 3.08,
    cy: 3.08,
    r: 3.08,
    transform: "translate(9.104 48.251)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeasehold);
export default __webpack_public_path__ + "static/media/leasehold.a2010241.svg";
export { ForwardRef as ReactComponent };